/**
 * EmYuBa / エミューバ ブランド定数。
 *
 * - EmYu-Ba … ロゴ・画面上のブランド表記（大文字小文字を変えない）
 * - EmYuBa  … ドメイン・正式サービス識別子（コード・設定・package）
 * - エミューバ … 日本語 UI
 *
 * いずれも同一プロダクト。レトロ専用に限定しない。
 */

/** ロゴ・ヒーロー等の画面上ブランド表記 */
export const BRAND_LOGO = 'EmYu-Ba';

/** 正式サービス識別子・ドメイン表記のベース（コード・設定・環境変数） */
export const BRAND_ID = 'EmYuBa';

/** 日本語 UI 向け名称 */
export const BRAND_JA = 'エミューバ';

/** package.json / npm / ホスト名向けの小文字識別子 */
export const BRAND_PACKAGE = 'emyuba';

/** ドキュメント title / OG 向けの短いキャッチ */
export const BRAND_TAGLINE_JA = 'ゲームを遊ぶ場';

/** UI 向けの「エミューバ - ゲームを遊ぶ場」一行表記 */
export const BRAND_LINE_JA = `${BRAND_JA} - ${BRAND_TAGLINE_JA}`;

/** UI 上のブランドアイコン（PWA アイコンと同系） */
export const BRAND_ICON_SRC = '/icons/icon-192.png';
